/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdgangAccessControl,
    AdgangAccessControlFromJSON,
    AdgangAccessControlToJSON,
} from '../models/AdgangAccessControl';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';

/**
 * 
 */
export class MeApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiMeAccessControlListGet without sending the request
     */
    async apiMeAccessControlListGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/me/access-control-list`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiMeAccessControlListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdgangAccessControl>>> {
        const requestOptions = await this.apiMeAccessControlListGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdgangAccessControlFromJSON));
    }

    /**
     */
    async apiMeAccessControlListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdgangAccessControl>> {
        const response = await this.apiMeAccessControlListGetRaw(initOverrides);
        return await response.value();
    }

}
